module.exports = __webpack_public_path__ + "2e6ce38f2e568d6f4b886e49dd43fa59.png";